import { render } from "./SiteFooter.vue?vue&type=template&id=065a44a3&scoped=true"
const script = {}

import "./SiteFooter.vue?vue&type=style&index=0&id=065a44a3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-065a44a3"]])

export default __exports__